<h1 i18n  mat-dialog-title>Are you sure you want to delete this design?</h1>

<mat-dialog-actions>
    <button i18n class="mat-raised-button" (click)="close()">Close</button>
    <button i18n class="mat-raised-button mat-accent" (click)="delete()">Delete</button>
</mat-dialog-actions>